module.exports = __webpack_public_path__ + "static/media/cerrarSesion.f8e4a353.svg";